import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { environment } from "../../environments/environment";

@Injectable({ providedIn: "root" })
export class PermitToStayService {
    constructor(private http: HttpClient) { }

    getStudentOrientationPermitsToStay(studentId: number) {
        return this.http.get<any>(`${environment.apiUrl}/PortalPermitToStay/GetStudentOrientationPermitsToStay?studentId=${studentId}`);
    }

    getStudentOrientationPermitToStay(orientationPermitToStayStudentId: number) {
        return this.http.get<any>(`${environment.apiUrl}/PortalPermitToStay/GetStudentOrientationPermitToStay?orientationPermitToStayStudentId=${orientationPermitToStayStudentId}`);
    }

    getOrientationPermitToStayStudentSystemCheckListItems(orientationPermitToStayId: number) {
        return this.http.get<any>(`${environment.apiUrl}/PortalPermitToStay/GetOrientationPermitToStayStudentSystemCheckListItems?orientationPermitToStayId=${orientationPermitToStayId}`);
    }

    getOrientationPermitToStayStudentCheckListItems(orientationPermitToStayStudentId: number, funnelId: number, providerId?: number) {
        return this.http.get<any>(`${environment.apiUrl}/PortalPermitToStay/OrientationPermitToStayStudentCheckListItems?orientationPermitToStayStudentId=${orientationPermitToStayStudentId}&funnelId=${funnelId}&providerId=${providerId}`);
    }

    insertOrUpdateOrientationPermitToStayStudentCheckListItem(saveModel: any) {
        return this.http.post(`${environment.apiUrl}/PortalPermitToStay/InsertOrUpdateOrientationPermitToStayStudentCheckListItem`, saveModel);
    }

    markNonDocumentOrientationPermitToStayStudentCheckListItemAsCompleted(saveModel: any) {
        return this.http.post(`${environment.apiUrl}/PortalPermitToStay/MarkNonDocumentOrientationPermitToStayStudentCheckListItemAsCompleted`, saveModel);
    }

    getOrientationPermitToStayStudentAppointments(orientationPermitToStayStudentId: number) {
        return this.http.get<any>(`${environment.apiUrl}/PortalPermitToStay/GetOrientationPermitToStayStudentAppointments?orientationPermitToStayStudentId=${orientationPermitToStayStudentId}`);
    }
}